(() => {
  if (new URLSearchParams(window.location.search).get('spacing_debug') !== '1') return;

  document.documentElement.dataset.lussoSpacingDebug = 'true';

  const getModule = (section) => section.querySelector(
    ':scope > .ls-section, :scope > .ls-manifesto, :scope > .ls-shoe-layers, :scope > .ls-newsletter, :scope > [class^="ls-"]'
  );

  const update = () => {
    const isCollection = window.location.pathname.startsWith('/collections/');
    const sections = isCollection
      ? document.querySelectorAll('main > .shopify-section')
      : document.querySelectorAll('main > .shopify-section[class*="section-lusso-"]');

    sections.forEach((section) => {
      const module = isCollection
        ? section.querySelector('.collection-hero, [class*="section-"][class*="padding"], [class^="ls-"]')
        : getModule(section);
      if (!module) return;

      const styles = window.getComputedStyle(module);
      const top = Number.parseFloat(styles.paddingTop) || 0;
      const bottom = Number.parseFloat(styles.paddingBottom) || 0;
      module.style.setProperty('--ls-debug-padding-top', `${top}px`);
      module.style.setProperty('--ls-debug-padding-bottom', `${bottom}px`);
      module.classList.add('ls-spacing-debug-target');

      let overlay = module.querySelector(':scope > .ls-spacing-debug-overlay');
      if (!overlay) {
        overlay = document.createElement('div');
        overlay.className = 'ls-spacing-debug-overlay';
        overlay.setAttribute('aria-hidden', 'true');
        const sectionName = [...section.classList].find((name) => name.startsWith('section-lusso-')) || (module.classList.contains('collection-hero') ? 'collection banner' : 'product grid');
        overlay.innerHTML = `
          <span class="ls-spacing-debug-band ls-spacing-debug-band--top"></span>
          <span class="ls-spacing-debug-band ls-spacing-debug-band--bottom"></span>
          <span class="ls-spacing-debug-label">${sectionName.replace('section-lusso-', '').replaceAll('-', ' ')} · top ${Math.round(top)}px · bottom ${Math.round(bottom)}px</span>
        `;
        module.appendChild(overlay);
      } else {
        const label = overlay.querySelector('.ls-spacing-debug-label');
        const sectionName = [...section.classList].find((name) => name.startsWith('section-lusso-')) || (module.classList.contains('collection-hero') ? 'collection banner' : 'product grid');
        if (label) label.textContent = `${sectionName.replace('section-lusso-', '').replaceAll('-', ' ')} · top ${Math.round(top)}px · bottom ${Math.round(bottom)}px`;
      }

      const content = module.querySelector(':scope > .ls-container, :scope > * > .ls-container, :scope > .ls-store__module, :scope > .ls-newsletter__inner');
      content?.classList.add('ls-spacing-debug-content');
    });

    if (!document.querySelector('.ls-spacing-debug-legend')) {
      const legend = document.createElement('aside');
      legend.className = 'ls-spacing-debug-legend';
      legend.setAttribute('aria-hidden', 'true');
      legend.innerHTML = `
        <span class="ls-spacing-debug-key ls-spacing-debug-key--top">Top padding</span>
        <span class="ls-spacing-debug-key ls-spacing-debug-key--bottom">Bottom padding</span>
        <span class="ls-spacing-debug-key ls-spacing-debug-key--module">Module edge</span>
        <span class="ls-spacing-debug-key ls-spacing-debug-key--content">Content edge</span>
      `;
      document.body.appendChild(legend);
    }
  };

  const boot = () => window.requestAnimationFrame(update);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
  window.addEventListener('resize', update, { passive: true });
  document.addEventListener('shopify:section:load', boot);
})();
